import { ButtonClickType } from '@segment/analytics-next'

import { createButtonClickEvent } from '@/events'
import { computeEventLocationPct, constructFullUrl } from '@/helpers/ClientSideRenderHelper'
import { ClickEventHandlerInput } from '@/types'

import { useAnalytics } from './AnalyticsHook'

export const useElementClick = (type: ButtonClickType) => {
  const analytics = useAnalytics()

  const handleClickEventForSegment = ({ url, location, text = '', event }: ClickEventHandlerInput): void => {
    const eventProps = createButtonClickEvent({
      type,
      url: constructFullUrl(url || event.currentTarget?.getAttribute('href') || ''),
      location,
      text:
        text ||
        event.currentTarget?.innerText ||
        event?.currentTarget?.dataset?.testid ||
        (event.target as HTMLElement).innerText ||
        '',
      section: computeEventLocationPct(event),
    })

    analytics.trackEvent(eventProps)
  }

  return handleClickEventForSegment
}
